module.exports = __webpack_public_path__ + "img/project16_1.jpg.2701efe5.webp";